module.exports = __webpack_public_path__ + "static/media/room-06.e1e0a305.jpg";